import { linksPattern } from '@shared/utils/constants/patterns'
import {
  convertToVimeoEmbed,
  isVimeoLink,
} from '@shared/utils/helpers/embed-urls/vimeo-link'
import {
  convertToYoutubeEmbed,
  isYoutubeLink,
} from '@shared/utils/helpers/embed-urls/youtube-link'

export const convertToEmbedLink = (value?: string) => {
  const embeddedLinks = (value ?? '').match(linksPattern) ?? []

  const link = embeddedLinks[0]

  if (isVimeoLink(link)) {
    return convertToVimeoEmbed(link)
  } else if (isYoutubeLink(link)) {
    return convertToYoutubeEmbed(link)
  } else {
    return link
  }
}

export const isYoutubeOrVimeoLink = (value?: string) =>
  isVimeoLink(value) || isYoutubeLink(value)
